import {FORM_DIRECTIVES, REACTIVE_FORM_DIRECTIVES, FORM_PROVIDERS, FormGroup, FormControl} from "@angular/forms";
import {AlertComponent, TYPEAHEAD_DIRECTIVES, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS} from "ng2-bootstrap/ng2-bootstrap";
import {Component, OnDestroy, OnInit, Input, Output} from "@angular/core";
import {VehicleBrand} from "../../domain/vehicleBrand";
import {DEFAULT_ERROR_MESSAGES} from "../../validators/validators";
import {VehicleBrandService} from "../../service/vehicleBrand.service";
import {ActivatedRoute} from "@angular/router";
import {EventEmitter} from "@angular/router-deprecated/src/facade/async";

/**
 * .
 * Created by jlado on 5/9/16.
 */
@Component({
    selector: 'vehicleBrand-editor',
    template: require('./vehicleBrand.editor.component.html'),
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        TYPEAHEAD_DIRECTIVES,
        MODAL_DIRECTIVES,
    ],
    providers: [
        FORM_PROVIDERS,
        BS_VIEW_PROVIDERS
    ],
})
export class VehicleBrandEditorComponent implements OnInit, OnDestroy {

    @Input() public vehicleBrand:VehicleBrand;
    @Output() private close = new EventEmitter();

    public errorMessages:any;
    public errorMessage:string;
    public successMessage:string;

    private sub:any;
    public form:FormGroup;

    public vehicleBrandId:string;

    public createMode:boolean;
    public loading:boolean;

    constructor(private vehicleBrandService:VehicleBrandService,
                private route:ActivatedRoute) {
        this.init();
    }

    private init():void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.loading = false;

        this.vehicleBrand = new VehicleBrand();
    }

    public ngOnInit():any {
        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            let vehicleBrandId = params['vehicleBrandId'];
            if (vehicleBrandId) {
                this.vehicleBrandId = vehicleBrandId;
                this.createMode = false;
            } else {
                this.vehicleBrandId = null;
                this.createMode = true;
            }
            this.getData();
        });
    }

    public ngOnDestroy():any {
        this.sub.unsubscribe();
    }

    private createFormGroup():void {
        let group:any = {};
        group['name'] = new FormControl(this.vehicleBrand.name);
        this.form = new FormGroup(group);
    }

    private getData():void {
        if (this.vehicleBrandId) {
            this.loading = true;
            this.vehicleBrandService.getVehicleBrand(this.vehicleBrandId).subscribe(
                (data) => {
                    this.setData(data);
                },
                () => {
                    this.bindError('Ocurrió un error al obtener los datos de la marca del vehículo.');
                });
        }
    }

    private setData(data:any):void {
        this.loading = false;

        if (this.vehicleBrandId) {
            this.vehicleBrand = data;
        } else {
            this.vehicleBrand = new VehicleBrand();
        }
    }

    public save():void {
        this.clearMessages();
        this.loading = true;

        this.vehicleBrandService.save(this.vehicleBrand).subscribe(
            (saved:VehicleBrand) => {
                this.loading = false;
                this.vehicleBrand = saved;
                this.successMessage = 'La marca de vehículo se guardó con éxito';
                this.updateViewAfterSave();
            },
            () => {
                this.bindError('Ocurrió un error al guardar los datos de la marca de vehículo.');
            });
    }

    private clearMessages():void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    private updateViewAfterSave():void {
        if (this.createMode) {
            this.vehicleBrand = new VehicleBrand();
        }
    }

    public goBack(event:any):void {
        event.preventDefault();
        this.close.emit(this.vehicleBrand);
        window.history.back();
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/vehicleBrands/vehicleBrand.editor.component.ts
 **/